import React, { useState } from "react";

const AdminDashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="left-0 z-45 w-full mt-8">
      <div className="flex h-screen bg-gray-100">
        {/* Sidebar */}
        <aside
          className={`fixed inset-y-0 left-0 w-64 bg-gray-800 text-white transform ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform md:relative md:translate-x-0`}
        >
          <div className="p-6 text-center text-2xl font-bold">LMS Admin</div>
          <nav className="mt-6">
            <ul>
              <li className="mb-4">
                <a href="#" className="block p-4 hover:bg-gray-700">
                  Dashboard
                </a>
              </li>
              <li className="mb-4">
                <a href="#" className="block p-4 hover:bg-gray-700">
                  Users
                </a>
              </li>
              <li className="mb-4">
                <a href="#" className="block p-4 hover:bg-gray-700">
                  Courses
                </a>
              </li>
              <li className="mb-4">
                <a href="#" className="block p-4 hover:bg-gray-700">
                  Feedback
                </a>
              </li>
              <li className="mb-4">
                <a href="#" className="block p-4 hover:bg-gray-700">
                  Reports
                </a>
              </li>
            </ul>
          </nav>
        </aside>

        {/* Hamburger Menu Button */}
        <button
          className="fixed top-4 left-4 bg-gray-800 text-white p-2 rounded-md md:hidden"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Main Content */}
        <div className="flex-1 p-6 bg-gray-100 overflow-y-auto">
          {/* Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold text-gray-700">Total Users</h2>
              <p className="text-2xl font-bold text-gray-800 mt-2">1,234</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold text-gray-700">Active Courses</h2>
              <p className="text-2xl font-bold text-gray-800 mt-2">56</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold text-gray-700">Feedbacks</h2>
              <p className="text-2xl font-bold text-gray-800 mt-2">420</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold text-gray-700">Reports</h2>
              <p className="text-2xl font-bold text-gray-800 mt-2">89</p>
            </div>
          </div>

          {/* Recent Activity Table */}
          <div className="mt-8 bg-white rounded-lg shadow-md p-6">
            <h2 className="text-lg font-bold mb-4">Recent Activities</h2>
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr>
                  <th className="border px-4 py-2 text-left">User</th>
                  <th className="border px-4 py-2 text-left">Action</th>
                  <th className="border px-4 py-2 text-left">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-2">John Doe</td>
                  <td className="border px-4 py-2">Enrolled in React Course</td>
                  <td className="border px-4 py-2">Jan 1, 2025</td>
                </tr>
                <tr>
                  <td className="border px-4 py-2">Jane Smith</td>
                  <td className="border px-4 py-2">Submitted Feedback</td>
                  <td className="border px-4 py-2">Jan 3, 2025</td>
                </tr>
                <tr>
                  <td className="border px-4 py-2">Robert Brown</td>
                  <td className="border px-4 py-2">Generated Report</td>
                  <td className="border px-4 py-2">Jan 4, 2025</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
